import React, { useEffect, useState } from "react";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Space, Tabs, TabsProps } from "antd";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Common from "../commons/common";

import OrderDigitalKey from "../components/OrderDigitalKey";
import ModalAddCarOwner from "../components/ModalAddCarOwner";
import RentDigitalKey from "../components/RentDigitalKey";

export type ControlDoorType = {
    carId: number;
    doorType: string;
    control: string;
};

function DigitalKey() {
    const [refreshComponent, setRefreshComponent] = useState(false);

    const [openModalAddCarOwner, setOpenModalAddCarOwner] = useState(false);

    const onControlDoor = (doorControl: ControlDoorType) => {
        const requestUrl =
            Request.DOOR_CAR_URL +
            doorControl.carId +
            "/door/" +
            (doorControl.doorType === Common.DOOR_TYPE_SWING ? doorControl.doorType + "/" : "") +
            doorControl.control;

        console.log("requestUrl", requestUrl);
        requestControlDoor(requestUrl);
    };

    const requestAxiosControlDoor = async (url: string) => {
        const response = await utilAxiosWithAuth().post(url);
        return response.data;
    };

    const {
        loading: loadingControlDoor,
        error: errorControlDoor,
        data: resultControlDoor,
        execute: requestControlDoor,
    } = useAsyncAxios(requestAxiosControlDoor);

    useEffect(() => {
        if (resultControlDoor === null) return;
        console.log("resultControlDoor", resultControlDoor);
        setRefreshComponent(true);
    }, [resultControlDoor]);

    useEffect(() => {
        if (errorControlDoor === null) return;

        console.log("errorControlDoor", errorControlDoor);
    }, [errorControlDoor]);

    const showModalAddCarOwner = () => {
        setOpenModalAddCarOwner(true);
    };

    const onDeleteCarOwner = (carOwnerId: number) => {
        requestDeleteCar(carOwnerId);
    };

    const requestAxiosDeleteCar = async (carOwnerId: number) => {
        const response = await utilAxiosWithAuth().delete(Request.CAR_OWNERS + "/" + carOwnerId);
        return response.data;
    };

    const { loading: loadingDeleteCar, error: errorDeleteCar, data: resultDeleteCar, execute: requestDeleteCar } = useAsyncAxios(requestAxiosDeleteCar);

    useEffect(() => {
        if (resultDeleteCar === null) return;
        console.log("resultDeleteCar", resultDeleteCar);
        setRefreshComponent(true);
    }, [resultDeleteCar]);

    useEffect(() => {
        if (errorDeleteCar === null) return;

        console.log("errorDeleteCar", errorDeleteCar);
    }, [errorDeleteCar]);

    const onAddCarOwner = (car: Types.CarDto, user: Types.UserDto) => {
        requestRegisterCar(car, user);
    };

    const requestAxiosRegisterCar = async (car: Types.CarDto, user: Types.UserDto) => {
        const response = await utilAxiosWithAuth().post(Request.CAR_OWNERS, { car: car, user: user, active: true });
        return response.data;
    };

    const {
        loading: loadingRegisterCar,
        error: errorRegisterCar,
        data: resultRegisterCar,
        execute: requestRegisterCar,
    } = useAsyncAxios(requestAxiosRegisterCar);

    useEffect(() => {
        if (resultRegisterCar === null) return;
        console.log("resultRegisterCar", resultRegisterCar);
        setRefreshComponent(true);
    }, [resultRegisterCar]);

    useEffect(() => {
        if (errorRegisterCar === null) return;

        console.log("errorRegisterCar", errorRegisterCar);
    }, [errorRegisterCar]);

    const digitalKeyItems: TabsProps["items"] = [
        {
            key: "1",
            label: "판매",
            children: (
                <>
                    <OrderDigitalKey
                        refresh={refreshComponent}
                        setRefresh={setRefreshComponent}
                        onControlDoor={onControlDoor}
                        onAddCarOwner={showModalAddCarOwner}
                        onDeleteCarOwner={onDeleteCarOwner}
                    />
                    <ModalAddCarOwner
                        open={openModalAddCarOwner}
                        onChangedOpen={(open: boolean) => setOpenModalAddCarOwner(open)}
                        onAddCarOwner={onAddCarOwner}
                    />
                </>
            ),
        },
        {
            key: "2",
            label: "렌트",
            children: (
                <>
                    <RentDigitalKey
                        refresh={refreshComponent}
                        setRefresh={setRefreshComponent}
                        onControlDoor={onControlDoor}
                        onAddCarOwner={showModalAddCarOwner}
                        onDeleteCarOwner={onDeleteCarOwner}
                    />
                </>
            ),
        },
    ];

    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">디지털 키 관리</h3>
                <Tabs defaultActiveKey="1" items={digitalKeyItems} />
            </Space>
        </div>
    );
}

export default DigitalKey;
